<template>
    <div @click="togglePopover" class="header-acc" :class="[$attrs.class, { 'active-popover': popover?.visible }]">
        <PersonAvatar :name="person?.name" :person_id="person?.id || 0" :width="50" :height="40" />
       
        <div class="acc-wrapper">
            <div class="name-div">
                <span>{{ person?.name }}</span>
                <!-- simulation of upgrade license -->
                <p v-if="person?.name">{{ person.license? person.license.type : 'Unlicensed' }}</p>
                <p v-else>Loading...</p>
            </div>
            <div class="icon-drop">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M5.83325 12.5L9.99992 16.6666L14.1666 12.5M5.83325 7.49998L9.99992 3.33331L14.1666 7.49998"
                        stroke="#A4A7AE"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
    </div>

    <PrimePopover ref="popover" class="w-full lg:w-auto px-[16px] lg:px-0">
        <AccountPopover @hidePopover="hidePopover"/>
    </PrimePopover>
</template>
<script setup lang="ts">
import PrimePopover from 'primevue/popover';
import PersonAvatar from '~/components/main/shared/PersonAvatar.vue';
import { usePersonStore } from '~/stores/person';
import AccountPopover from './AccountPopover.vue';
const store = usePersonStore();
const popover = ref();

const {person} = storeToRefs(store);

const togglePopover = (event: any) => {
    popover.value.toggle(event);
};

const hidePopover = () => {
    popover.value.hide();
};
</script>
<style lang="scss" scoped>
.header-acc {
    @apply p-3 lg:w-[280px] cursor-pointer items-start gap-4 rounded-lg border lg:border-[#E9EAEB] bg-[#18181B] lg:bg-[#FFFFFF];

    &:hover {
        transform: translateY(-1px);
        @apply shadow-md bg-[#27272A] lg:bg-[#fdfdfdc2];
    }

    &.active-popover {
    transform: translateY(-1px);
    @apply shadow-md bg-[#27272A] lg:bg-[#fdfdfdc2];
  }

    .icon-div {
        @apply flex justify-center items-center w-10 h-10 p-2 aspect-square rounded-full border border-[#E9EAEB] bg-[#F5F5F5];
    }

    .acc-wrapper {
        @apply flex justify-between items-center w-full;

        .name-div {
            @apply flex flex-col items-start;

            span {
                @apply text-[#FFFFFF] lg:text-[#181D27] text-sm font-semibold leading-5 font-inter;
            }
            p {
                @apply text-[#A4A7AE] lg:text-[#535862] text-sm font-normal leading-5 font-inter overflow-hidden text-ellipsis line-clamp-1;
            }
        }

        .icon-drop {
            @apply flex w-8 h-8 p-1.5 justify-center items-center content-center flex-wrap rounded-[6px];
        }
    }
}

</style>
